// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__JHc66","location":"Header_location__1tnlO"};